export default __webpack_public_path__ + "static/media/bmp.6fd28d16.png";